import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TraceKeysApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export type UpdateTraceKeyParams = {
  traceKeyId: number
  name: string
}

export const useMutationUpdateTraceKey = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: UpdateTraceKeyParams) => {
      return await baseClient
        .getApi(TraceKeysApi)
        .updateTraceKey({
          traceKeyId: params.traceKeyId,
          updateTraceKeyRequestBody: {
            name: params.name,
          },
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.lists() })
    },
  })
}
